import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useSubheadingStyles = createUseStyles({
  subheadingWrapper: {
    margin: '2rem 0 1.5rem 0',
    color: colors.text
  }
})

export { useSubheadingStyles }
